import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const InsuranceOrderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  overflow: hidden;
`;

export const InsuranceOrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey004};
`;

export const InsuranceOrderTitle = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const InsuranceOrderCount = styled.span`
  color: ${({ theme }) => theme.colors.grey002};
  font-size: 13px;
`;

export const InsuranceOrderRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey004};

  &:last-child {
    border-bottom: none;
  }
`;

export const InsuranceOrderThumb = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 4px;
  flex-shrink: 0;
`;

export const InsuranceOrderTextCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const InsuranceOrderName = styled(typography.BodyTextOneRegularTypography)`
  margin: 0 0 4px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const InsuranceOrderIngredient = styled(typography.BodyTextOneRegularTypography)`
  margin: 0 0 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const InsuranceOrderMetaLine = styled(typography.BodyTextOneRegularTypography)`
  margin: 0 0 4px;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const InsuranceOrderDiscountPrices = styled.div`
  margin: 6px 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const InsuranceOrderPriceBeforeStruck = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.grey002};
  text-decoration: line-through;
  text-decoration-thickness: 1px;
`;

export const InsuranceOrderPriceAfter = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const InsuranceOrderNotes = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black};
`;

export const InsuranceOrderMessage = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 12px 16px;
  color: ${({ theme }) => theme.colors.grey002};
`;
